import { useState, useCallback, useEffect } from 'react';

export const useLanguage = (initialLang = 'es') => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Intentar recuperar el idioma guardado
    if (typeof window !== 'undefined') {
      const savedLang = localStorage.getItem('language');
      return savedLang || initialLang;
    }
    return initialLang;
  });

  // Guardar el idioma en localStorage cuando cambie
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', currentLanguage);
      document.documentElement.lang = currentLanguage;
    }
  }, [currentLanguage]);

  const toggleLanguage = useCallback(() => {
    setCurrentLanguage(prev => prev === 'es' ? 'en' : 'es');
  }, []);

  const translate = useCallback((text) => {
    if (!text) return '';
    
    if (typeof text === 'object') {
      return text[currentLanguage] || text.es || text.en || '';
    }
    
    // Si es un string, buscar en el objeto de traducciones
    const translations = {
      'Inicio': { es: 'Inicio', en: 'Home' },
      'Restaurantes': { es: 'Restaurantes', en: 'Restaurants' },
      'Blog': { es: 'Blog', en: 'Blog' },
      'Contacto': { es: 'Contacto', en: 'Contact' },
      'Directorio de Restaurantes Lima': { 
        es: 'Directorio de Restaurantes Lima', 
        en: 'Lima Restaurant Directory' 
      },
      'Descubre los Mejores Restaurantes de Lima': {
        es: 'Descubre los Mejores Restaurantes de Lima',
        en: 'Discover the Best Restaurants in Lima'
      },
      'Desde auténtico ceviche hasta alta cocina, explora la increíble gastronomía limeña': {
        es: 'Desde auténtico ceviche hasta alta cocina, explora la increíble gastronomía limeña',
        en: 'From authentic ceviche to haute cuisine, explore Lima\'s incredible gastronomy'
      },
      'Cambiar idioma': { es: 'Cambiar idioma', en: 'Change language' },
      'Abrir menú': { es: 'Abrir menú', en: 'Open menu' }
    };

    return translations[text]?.[currentLanguage] || text;
  }, [currentLanguage]);

  return {
    currentLanguage,
    toggleLanguage,
    translate,
    isSpanish: currentLanguage === 'es',
    isEnglish: currentLanguage === 'en'
  };
}; 